module.exports = __webpack_public_path__ + "img/saturn.7a8d4005.png";